require('bootstrap');
require('packs/jquery-ui');

(()=>{
  // =========================================================
  // Notification popover
  function popoverContent() {
    $.ajax({
      dataType: 'json',
      url: "/notifications_summary",
      method: "GET",
      success: function (data) {
        $('.notification-popover-body').html(data.html);
      }
    });
  }
   
  $('#notification-toggle-popover').popover({
    template: `
    <div class="notification-popover" role="tooltip">
      <div class="notification-popover-arrow"></div>
      <div class="popover-body notification-popover-body"></div>
    </div>`,
    html: true,
    content: function(){
      popoverContent();
      return '<div class="notification-loading"><div class="notification-loading__logo"></div></div>';
    }
  })
  // =========================================================
})()